<template>
  <div id="app">
    <router-view />

    <!-- 全局的登录弹窗 -->
    <login-dialog ref="loginDialog" />
  </div>
</template>

<script>
import loginDialog from '@/components/loginDialog/loginDialog.vue'
export default {
  name: 'App',
  components: { loginDialog },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss"></style>
